import { Layout, AddPlatform } from '@/views/platform';

export default {
    path: '/platform',
    component: Layout,
    children: [
        { path: 'add', component: AddPlatform },
    ]
};
